<template>
  <section v-if="showHeader" class="flex flex-col mt-4 sm:rounded-lg bg-slate-50 dark:bg-zinc-800 2xl:max-w-6xl 2xl:mx-auto">
    <RequestContentInfo />
    <SmartActions v-if="type === ItemType.VIDEO && hasAiAddon" />
    <ItemDescription />
    <Chapters />
  </section>
</template>
<script lang="ts" setup>
import { storeToRefs } from 'pinia';

import { useCallToActionStore } from '../store/useCallToActionStore';
import { useViewerItemStore, ItemType } from '../store/useViewerItemStore';
import { useAiMetadataStore } from '../store/useAiMetadataStore';
import { useAddon } from '@/modules/viewer/composables/useAddon';
import { useUser } from '../composables/useUser';

import ItemDescription from './Description.vue';
import Chapters from './Chapters.vue';
import RequestContentInfo from './RequestContentInfo.vue';
import SmartActions from './smart_actions/SmartActions.vue';
import { computed } from 'vue';

const { hasAiAddon } = useAddon();

const itemStore = useViewerItemStore();
const { description, requestContentId, type } = storeToRefs(itemStore);

const ctaStore = useCallToActionStore();
const { isHoverable, displayActionActive } = storeToRefs(ctaStore);

const aiMetadataStore = useAiMetadataStore();
const { hasChapters } = storeToRefs(aiMetadataStore);

const { isCurrentItemOwner } = useUser();

const showHeader = computed(
  () =>
    isCurrentItemOwner.value || description.value?.length || (!isHoverable.value && displayActionActive.value) || hasChapters.value || requestContentId?.value
);
</script>
